<template>
    <div class="d-flex flex-row">
        <input :type="inputType"
               class="form-control"
               autocomplete="false"
               :value="value"
               :placeholder="placeholder"
               @keyup="e => $emit('input', e.target.value)"
        >
        <div class="d-flex flex-column justify-content-center align-items-center"
             style="width: 50px; margin-left: -50px;"
             @click="isPasswordReadable = !isPasswordReadable"
        >
            <i v-if="isPasswordReadable" class="fas fa-eye"/>
            <i v-else class="fas fa-eye-slash"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        placeholder: String,
        showByDefault: Boolean
    },

    data() {
        return {
            isPasswordReadable: false
        }
    },

    mounted() {
        if (this.showByDefault) {
            this.isPasswordReadable = true;
        }
    },

    computed: {
        inputType() {
            if (this.isPasswordReadable) {
                return 'text';
            }

            return 'password';
        }
    }
}
</script>
